import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { useI18n } from "../../i18n";
import { api } from "../../lib/api";
import Navbar from "../../components/marketing/Navbar";
import Footer from "../../components/marketing/Footer";
import { Button } from "../../components/ui/button";

export default function Pricing() {
  const { t, lang, fmt } = useI18n();
  const nav = useNavigate();
  const [plans, setPlans] = useState([]);
  const [addons, setAddons] = useState([]);

  useEffect(() => {
    api.get("/plans").then(({ data }) => { setPlans(data.plans); setAddons(data.addons); });
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="max-w-7xl mx-auto px-6 pt-16 pb-8 text-center">
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-[hsl(217_63%_15%)]">{t("pricing_title")}</h1>
        <p className="mt-4 text-lg text-muted-foreground max-w-2xl mx-auto">{t("pricing_sub")}</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-8">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-5">
          {plans.map((p) => (
            <div key={p.id} data-testid={`plan-card-${p.id}`}
              className={`relative rounded-2xl border bg-card p-6 flex flex-col ${p.highlight ? "border-[hsl(158_64%_28%)] ring-1 ring-[hsl(158_64%_28%)] shadow-lg" : "border-border"}`}>
              {p.highlight && <span className="absolute -top-3 start-6 rounded-full bg-[hsl(158_64%_28%)] text-white text-xs px-3 py-1">{t("most_popular")}</span>}
              <div className="font-display font-bold text-xl text-[hsl(217_63%_15%)]">{lang === "ar" ? p.name_ar : p.name_en}</div>
              <div className="text-sm text-muted-foreground mt-1">{lang === "ar" ? p.tagline_ar : p.tagline_en}</div>
              <div className="mt-5">
                {p.price_monthly > 0 ? (
                  <div className="flex items-baseline gap-1">
                    <span className="font-mono text-3xl font-bold text-[hsl(217_63%_15%)]">{fmt(p.price_monthly)}</span>
                    <span className="text-sm text-muted-foreground">{t("sar")}{t("per_month")}</span>
                  </div>
                ) : (
                  <div className="font-mono text-3xl font-bold text-[hsl(217_63%_15%)]">{t("custom")}</div>
                )}
              </div>
              <ul className="mt-6 space-y-2.5 flex-1">
                {(lang === "ar" ? p.features_ar : p.features_en).map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm">
                    <Check className="h-4 w-4 text-[hsl(158_64%_28%)] mt-0.5 shrink-0" /><span className="text-foreground/80">{f}</span>
                  </li>
                ))}
              </ul>
              <Button data-testid={`plan-cta-${p.id}`} onClick={() => nav(p.price_monthly > 0 ? "/register" : "/contact")}
                className={`mt-6 rounded-full w-full ${p.highlight ? "bg-[hsl(158_64%_28%)] hover:bg-[hsl(158_64%_24%)]" : "bg-[hsl(217_63%_15%)] hover:bg-[hsl(217_63%_20%)]"}`}>
                {p.price_monthly > 0 ? t("choose_plan") : t("contact_sales")}
              </Button>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <h2 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("addons_title")}</h2>
        <p className="mt-2 text-muted-foreground">{t("addons_sub")}</p>
        <div className="mt-8 grid md:grid-cols-4 sm:grid-cols-2 gap-4">
          {addons.map((a) => (
            <div key={a.id} className="rounded-xl border border-border bg-card p-5">
              <div className="font-semibold text-sm text-[hsl(217_63%_15%)]">{lang === "ar" ? a.name_ar : a.name_en}</div>
              <div className="mt-3 font-mono text-lg font-bold text-[hsl(158_64%_28%)]">{fmt(a.fee)} <span className="text-xs text-muted-foreground">{t("sar")}</span></div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
